import { fmhAPI, SCOPE_ASSESSOR_API_URL } from 'api/APIBase';

/** Benefit check for a member */
export async function checkBenefitForMember({
    payerId,
    segmentId,
    cardholderId,
    dateOfBirth,
    firstName,
    lastName,
}) {
    const url = `${SCOPE_ASSESSOR_API_URL}/admin/${payerId}/benefits/benefit-check`;
    return fmhAPI.base
        .url(url)
        .query({
            cardholder_id: cardholderId,
            date_of_birth: dateOfBirth,
            first_name: firstName,
            last_name: lastName,
            segment_id: segmentId,
        })
        .get()
        .json();
}
